module.exports = __webpack_public_path__ + "media/images/shark/SharkUnderwater2-3e8214e3aa1417ee4aa823f776ad348b.jpg";